var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("b-table", {
        attrs: {
          striped: "",
          items: _vm.templateDocs,
          fields: _vm.templateFields
        },
        scopedSlots: _vm._u([
          {
            key: "enabled",
            fn: function(data) {
              return [
                _c(
                  "label",
                  { staticClass: "switch switch-3d switch-success" },
                  [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: data.item.enabled,
                          expression: "data.item.enabled"
                        }
                      ],
                      staticClass: "switch-input",
                      attrs: { type: "checkbox" },
                      domProps: {
                        checked: Array.isArray(data.item.enabled)
                          ? _vm._i(data.item.enabled, null) > -1
                          : data.item.enabled
                      },
                      on: {
                        change: [
                          function($event) {
                            var $$a = data.item.enabled,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = null,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  (data.item.enabled = $$a.concat([$$v]))
                              } else {
                                $$i > -1 &&
                                  (data.item.enabled = $$a
                                    .slice(0, $$i)
                                    .concat($$a.slice($$i + 1)))
                              }
                            } else {
                              _vm.$set(data.item, "enabled", $$c)
                            }
                          },
                          function($event) {
                            _vm.updateStatus(data.item)
                          }
                        ]
                      }
                    }),
                    _vm._v(" "),
                    _c("span", { staticClass: "switch-label" }),
                    _vm._v(" "),
                    _c("span", { staticClass: "switch-handle" })
                  ]
                )
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-15df04a0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-15df04a0","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/admin/formStatus.vue
// module id = 1417
// module chunks = 2